import { Reveal } from "@/components/Motion";

const Block = ({ title, children }) => (
  <Reveal className="mb-10">
    <h2 className="font-serif text-2xl md:text-3xl text-gold mb-4">{title}</h2>
    <div className="text-white/60 font-light leading-relaxed space-y-3">{children}</div>
  </Reveal>
);

export default function Confidentialite() {
  return (
    <div className="pt-32 pb-24" data-testid="confidentialite-page">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <Reveal>
          <p className="text-xs uppercase tracking-luxe text-gold mb-6">RGPD</p>
          <h1 className="font-serif text-5xl md:text-6xl text-white mb-14">Politique de Confidentialité</h1>
        </Reveal>

        <Block title="Responsable du traitement">
          <p>SYNERGIE VITA HOLDING (SAS), 55 route de la Démarche, 97233 SCHOELCHER, Martinique — gestion.svh@serenite-essence.fr.</p>
        </Block>

        <Block title="Données collectées">
          <p>Nous collectons les données que vous nous transmettez volontairement via nos formulaires (nom, email, téléphone, date de naissance) ainsi que des données de navigation soumises à votre consentement.</p>
        </Block>

        <Block title="Cookies & consentement">
          <p>Notre site utilise Google Consent Mode v2. Par défaut, aucun cookie de mesure d'audience ou publicitaire n'est activé (stockage « denied »). Vous pouvez à tout moment accepter, refuser ou personnaliser vos choix via le bandeau de consentement.</p>
          <p>Les outils concernés incluent Google Ads, Google Analytics 4 et le Pixel Meta, activés uniquement après votre accord.</p>
        </Block>

        <Block title="Vos droits">
          <p>Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, de portabilité et d'opposition. Pour l'exercer, contactez-nous à gestion.svh@serenite-essence.fr.</p>
        </Block>

        <Block title="Conservation">
          <p>Vos données sont conservées pour la durée strictement nécessaire aux finalités poursuivies, puis supprimées ou anonymisées.</p>
        </Block>
      </div>
    </div>
  );
}
